export const messageWidth = 700;
export const defaultBodyBorderWidth = 0;
export const defaultBodyBorderColor = '#000000';
export const defaultBodyBorderStyle = 'solid';
//# sourceMappingURL=message-defaults.js.map